import { config } from '@iheartjane/config';

export const authenticationUrls = {
  appleAuthentication: () => `${config.apiPath}/users/id_tokens/apple`,
  googleAuthentication: () => `${config.apiPath}/auth/google_oauth2/callback`,
  resetPassword: () => `${config.apiPath}/reset_password_request`,
  userSession: () => `${config.apiPath}/sessions`,
  userRegister: () => `${config.apiPath}/users`,
};
